import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = 'country';
export class CountryApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
}
